import { render, staticRenderFns } from "./ModalEditCertificate.vue?vue&type=template&id=4e2a6f87&scoped=true"
import script from "./ModalEditCertificate.vue?vue&type=script&lang=ts"
export * from "./ModalEditCertificate.vue?vue&type=script&lang=ts"
import style0 from "./ModalEditCertificate.vue?vue&type=style&index=0&id=4e2a6f87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2a6f87",
  null
  
)

export default component.exports